import React from 'react';
import PropTypes from 'prop-types';
import { LandingHeroGradient } from 'site-modules/shared/components/car-reviews-landing-hero/landing-hero-gradient/landing-hero-gradient';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';

export function LandingHero({
  breadcrumbsData = null,
  subTitle = null,
  isMobile = false,
  childrenClassName = 'container px-lg-0',
  imageUrl = null,
  trackingParent = null,
  children = null,
  noParallax = false,
  alt = '',
  subTitleClassName = 'fw-normal size-16',
  breadcrumbsClassName = '',
  ...rest
}) {
  const breadcrumbs = !!breadcrumbsData && (
    <Breadcrumbs
      data={breadcrumbsData.map(breadcrumb => ({
        ...breadcrumb,
        attrs: { ...breadcrumb.attrs, className: 'text-white' },
      }))}
      itemClassName="text-white"
      className="ps-0 text-white"
    />
  );
  return (
    <LandingHeroGradient
      {...rest}
      imageUrl={imageUrl}
      trackingParent={trackingParent}
      noParallax={noParallax}
      alt={alt}
      subTitleClassName={subTitleClassName}
      breadcrumbsClassName={breadcrumbsClassName}
      childrenClassName={childrenClassName}
      breadcrumbs={breadcrumbs}
      subTitle={subTitle}
      isMobile={isMobile}
    >
      {children}
    </LandingHeroGradient>
  );
}

LandingHero.propTypes = {
  title: PropTypes.string.isRequired,
  alt: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  breadcrumbsData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
      dataTrackingId: PropTypes.string,
    })
  ),
  imageUrl: PropTypes.string,
  trackingParent: PropTypes.string,
  children: PropTypes.node,
  breadcrumbsClassName: PropTypes.string,
  childrenClassName: PropTypes.string,
  subTitleClassName: PropTypes.string,
  noParallax: PropTypes.bool,
  isMobile: PropTypes.bool,
};
